__turbopack_context__.v({
  "checkbox": "CheckboxInput-module-scss-module__FoNSpG__checkbox",
  "checkbox__input": "CheckboxInput-module-scss-module__FoNSpG__checkbox__input",
  "checkbox__label": "CheckboxInput-module-scss-module__FoNSpG__checkbox__label",
});
